import {makeStyles} from "@material-ui/core";

export default function useStyles(styles){
    return makeStyles(styles);
}